var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFormatTextIncreaseIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h24v24H0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#006C8E",
  d: "M1 19 6.25 5h2.5L14 19h-2.4l-1.275-3.575h-5.65L3.4 19H1zm4.4-5.6h4.2L7.55 7.6h-.1L5.4 13.4zM18 16v-3h-3v-2h3V8h2v3h3v2h-3v3h-2z"
}))));
export default SvgFormatTextIncreaseIcon;